<ion-content [fullscreen]="true"
  class="first-login-content">
  <div class="first-login-workspace">
    <header class="first-login-workspace__header">
      <div class="first-login-workspace__brand">
        <span class="first-login-workspace__brand-eyebrow">{{ 'firstLogin.brandEyebrow' | translate }}</span>
        <h1>Urakka.app</h1>
      </div>
      <p class="first-login-workspace__progress-label">
        {{ 'firstLogin.progressLabel' | translate:{ current: currentStep(), total: totalSteps() } }}
      </p>
    </header>

    <div class="first-login-workspace__progress">
      <div class="first-login-workspace__progress-fill"
        [ngClass]="progressFillClass()"></div>
    </div>

    <section class="first-login-workspace__stage"
      [attr.data-step]="currentStepKey()">
      @switch (currentStepKey()) {
        @case ('welcome') {
          <div class="first-login-step first-login-step--welcome">
            <p class="first-login-step__eyebrow first-login-step__eyebrow--hero">{{ 'firstLogin.welcome.eyebrow' | translate }}</p>
            <h2 class="first-login-step__hero-title">Urakka.app</h2>
            @if (userName().length > 0) {
              <p class="first-login-step__lead">{{ 'firstLogin.welcome.greetingNamed' | translate:{ name: userName() } }}</p>
            } @else {
              <p class="first-login-step__lead">{{ 'firstLogin.welcome.greeting' | translate }}</p>
            }
            <h3 class="first-login-step__subtitle">{{ 'firstLogin.welcome.title' | translate }}</h3>
            <p class="first-login-step__body">{{ 'firstLogin.welcome.text' | translate }}</p>
          </div>
        }
        @case ('howItWorks') {
          <div class="first-login-step">
            <p class="first-login-step__eyebrow">{{ 'firstLogin.howItWorks.eyebrow' | translate }}</p>
            <h2>{{ 'firstLogin.howItWorks.title' | translate }}</h2>
            <p class="first-login-step__body">{{ 'firstLogin.howItWorks.text' | translate }}</p>
            <div class="first-login-step__cards">
              <article class="first-login-step__card">
                <p>{{ 'firstLogin.howItWorks.point1' | translate }}</p>
              </article>
              <article class="first-login-step__card">
                <p>{{ 'firstLogin.howItWorks.point2' | translate }}</p>
              </article>
              <article class="first-login-step__card">
                <p>{{ 'firstLogin.howItWorks.point3' | translate }}</p>
              </article>
            </div>
          </div>
        }
        @case ('fieldOs') {
          <div class="first-login-step">
            <p class="first-login-step__eyebrow">{{ 'firstLogin.fieldOs.eyebrow' | translate }}</p>
            <h2>{{ 'firstLogin.fieldOs.title' | translate }}</h2>
            <p class="first-login-step__body">{{ 'firstLogin.fieldOs.text' | translate }}</p>
            <ul class="first-login-step__list first-login-step__list--highlights">
              <li>{{ 'firstLogin.fieldOs.point1' | translate }}</li>
              <li>{{ 'firstLogin.fieldOs.point2' | translate }}</li>
              <li>{{ 'firstLogin.fieldOs.point3' | translate }}</li>
            </ul>
          </div>
        }
        @case ('workspace') {
          <div class="first-login-step first-login-step--workspace">
            <p class="first-login-step__eyebrow">{{ 'firstLogin.workspace.eyebrow' | translate }}</p>
            <h2>{{ 'firstLogin.workspace.title' | translate }}</h2>
            <p class="first-login-step__body">{{ 'firstLogin.workspace.text' | translate }}</p>

            <div class="first-login-workspace-create">
              <h3 class="first-login-workspace-create__title">{{ 'firstLogin.workspace.createTitle' | translate }}</h3>
              <p class="first-login-workspace-create__text">{{ 'firstLogin.workspace.createText' | translate }}</p>
              <ion-item lines="none"
                class="first-login-workspace-create__field">
                <ion-input [value]="workspaceName()"
                  [label]="'firstLogin.workspace.nameLabel' | translate"
                  labelPlacement="stacked"
                  (ionInput)="onWorkspaceName($any($event).detail?.value ?? null)">
                </ion-input>
              </ion-item>
              <ion-button color="primary"
                [disabled]="workspaceName().trim().length < 2 || workspaceLoading() || workspaceCreated()"
                (click)="onWorkspaceChoice('create'); createWorkspace()">
                @if (workspaceCreated()) {
                  {{ 'firstLogin.workspace.created' | translate }}
                } @else if (workspaceLoading()) {
                  {{ 'general.pleaseWait' | translate }}
                } @else {
                  {{ 'firstLogin.workspace.createButton' | translate }}
                }
              </ion-button>
              @if (workspaceError()) {
                <p class="first-login-workspace-create__error">{{ workspaceError() | translate }}</p>
              }
            </div>
          </div>
        }
        @case ('terms') {
          <div class="first-login-step first-login-step--terms">
            <p class="first-login-step__eyebrow">{{ 'firstLogin.terms.eyebrow' | translate }}</p>
            <h2>{{ 'firstLogin.terms.title' | translate }}</h2>
            <p class="first-login-step__body">{{ 'firstLogin.terms.summary' | translate }}</p>
            <div class="first-login-step__readiness">
              <span>{{ 'firstLogin.terms.readiness1' | translate }}</span>
              <span>{{ 'firstLogin.terms.readiness2' | translate }}</span>
            </div>
            <div class="first-login-step__terms-content"
              [innerHTML]="'terms.termsOfUse' | translate"></div>
            <ion-item lines="none"
              class="first-login-step__terms-accept">
              <ion-checkbox [checked]="termsAccepted()"
                (ionChange)="onTermsAccepted($event)">
                {{ 'firstLogin.terms.accept' | translate }}
              </ion-checkbox>
            </ion-item>
          </div>
        }
        @case ('ready') {
          <div class="first-login-step first-login-step--ready">
            <p class="first-login-step__eyebrow">{{ 'firstLogin.ready.eyebrow' | translate }}</p>
            <h2>{{ 'firstLogin.ready.title' | translate }}</h2>
            <p class="first-login-step__body">{{ 'firstLogin.ready.text' | translate }}</p>
          </div>
        }
      }
    </section>

    <footer class="first-login-workspace__actions"
      [class.is-welcome]="isWelcomeStep()">
      <div class="first-login-workspace__actions-left">
        @if (step() > 1 && !isReadyStep()) {
          <ion-button fill="clear"
            color="medium"
            (click)="prevStep()">
            {{ 'general.back' | translate }}
          </ion-button>
        }
      </div>
      <div class="first-login-workspace__actions-right">
        @if (showSkipIntro()) {
          <ion-button fill="clear"
            color="medium"
            (click)="skipIntro()">
            {{ 'firstLogin.actions.skipIntro' | translate }}
          </ion-button>
        }
        <ion-button color="light"
          [disabled]="!canContinue()"
          (click)="nextStep()">
          @if (isReadyStep()) {
            {{ 'firstLogin.actions.enter' | translate }}
          } @else if (isTermsStep()) {
            {{ 'firstLogin.actions.acceptAndContinue' | translate }}
          } @else if (isWorkspaceStep() || isWelcomeStep()) {
            {{ 'general.continue' | translate }}
          } @else {
            {{ 'general.next' | translate }}
          }
        </ion-button>
      </div>
    </footer>
  </div>
</ion-content>
